// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3663g","row":"ProcedureTreatmentSummary_row__17eSq"};